import fetch from '@/axios/promise';
import  {FLOW_URL, EXT_URL, HIELES_URL} from  '@/config/constant';
import qs from 'qs';

// 获取列表数据
export function page(query) {
  return invoke(query,'/queryFlowList','POST');
}
//通过主键获取flowInfo信息
export function getFlowInfoById(query) {
  return invoke(query, '/getFlowInfoById', 'POST')
}
//保存流程数据
export function saveFlowData(query) {
  return invoke(query,'/saveFlowData','POST')
}
//修改审批状态和审批人
export function updateApprInfo(query) {
  return invoke(query, '/updateApprInfo', 'POST')
}
//删除流程数据
export function deleteFlowData(query){
  return invoke(query, '/deleteFlowData', 'POST');
}


export function getExtFieldByExtTypeCode(query) {
  return invoke2(query, '/getExtFieldByExtTypeCode', 'POST')
}
//取得类别
export function getFlowTypeList(query){
  return invoke2(query,'/getFlowTypeList','POST')
}

//保存流程审批历史节点信息
export function saveHiElement(query) {
  return invoke3(query, '/saveHiElement', 'POST')
}

//查找历史审批节点
export  function getHiEleInfo(query) {
  return invoke3(query, '/getHiEleInfo', 'POST')
}

//删除图片通过fileId
export function delFlowAttachByFileId(query){
  return invoke(query, '/delFlowAttachByFileId', 'POST');
}

function invoke(query,url,method){
  return fetch({
    url: FLOW_URL + url,
    method: method,
    params: query
  });
}

function invoke2(query,url,method){
  return fetch({
    url: EXT_URL + url,
    method: method,
    params: query
  });
}

function invoke3(query,url,method){
  return fetch({
    url: HIELES_URL + url,
    method: method,
    params: query
  });
}

// 调用
// data 参数， 需要传递 format data 类型，或者后台 参数 添加 @RequestBody接收
//eg: let postData= new URLSearchParams()
//postData.append('param1',  value1)
//postData.append('param2',  value1)



// WEBPACK FOOTER //
// ./src/api/flow/flow.js